module.exports = __webpack_public_path__ + "img/img13.889b73c4.png";